<template>
  <div class="zone-icon" :style="{backgroundImage: `url(${image})`}"/>
</template>

<script>
export default {
  name: "ZoneIcon",
  props: ['iconName'],
  computed: {
    image() {
      return require(`./../../../assets/img/icons/${this.iconName}.png`);
    }
  }
}
</script>

<style scoped>
.zone-icon {
  width: 1.5rem;
  height: 1.5rem;
  background-size: contain;
  background-position: center;
  display: inline-block;
  background-repeat: no-repeat;
  overflow: visible;
  vertical-align: -0.3em;
}
</style>
